export function isVideo (file) {
    if (file.type.toLowerCase().match(/mp4|mov|avi/)) {
      return true;
    }
    return false;
};